import {createTable, RenderingPresetType, TableHeaderSpec} from "../../../../../components/table/CreateTable.tsx";
import * as React from "react";
import GLAPill from "../../../../../components/specific/GLAPill.tsx";
import { DEFAULT_GL_ACCOUNT, GlAccount } from "../../../../../hooks/useGLAccounts.ts";
import {BlacklistRulePreviewTransaction} from "./types.ts";

interface Props {
    transactions: BlacklistRulePreviewTransaction[];
    glAccounts: GlAccount[];
}

export function BlacklistRulePreviewTable({ transactions, glAccounts }: Props) {

    const tableSpec: TableHeaderSpec<BlacklistRulePreviewTransaction> = {
        title: `${transactions.length} transacties`,
        columns: [
            {
                name: 'Klant',
                field: 'business_name',
            },
            {
                name: 'Relatie',
                field: 'relation_name',
            },
            {
                name: 'Relatie IBAN',
                field: 'relation_iban',
            },
            {
                name: 'Grootboekrekening',
                field: 'general_ledger_account_id',
                customRender: (row: BlacklistRulePreviewTransaction) => {
                    const account = glAccounts.find(acc => acc.id === row.general_ledger_account_id);
                    const label = account?.label_nl || 'Ongecategoriseerd';
                    const icon = account?.icon ?? DEFAULT_GL_ACCOUNT.icon;

                    return (
                        <GLAPill
                            icon={icon}
                            label={label}
                        />
                    );
                }
            },
            {
                name: "Omschrijving",
                field: 'description',
            },
            {
                name: "Datum",
                field: 'booking_date',
                renderingPreset: RenderingPresetType.Date
            },
            {
                name: "Bedrag",
                field: 'signed_amount',
                renderingPreset: RenderingPresetType.MoneyColorAid
            }
        ],

        options: {

            hideTableHeader: false,
            disableTopPaginationWidget: true,
            disableBottomPaginationWidget: true,
        },
    };

    const TableComponent = createTable<BlacklistRulePreviewTransaction>(transactions, tableSpec);

    return (
        <div className='w-full'>
            {TableComponent()}
        </div>
    )
}
